/* eslint camelcase: ["warn", {allow: ["^UNSAFE_"]}] */
import { useAuthentication } from "./context.mjs";
export { useAuthentication, AuthenticationContext } from "./context.mjs";
export { default as UNSAFE_AuthStorage } from "./auth-storage.mjs";
export { AuthenticationProvider } from "./provider.mjs";
export default useAuthentication;